module.exports = __webpack_public_path__ + "img/corneal-neovascularisation-1.bd59cd59.jpg";